<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/student-follow-up-graduate/store';

export default {
  name: 'StudentFollowUpWrapper',
  created() {
    this.loadMessages(['18018']);
    if (this.$store.state[name] == undefined) {
      this.$store.registerModule(name, store);
    }
  },
  destroyed() {
    this.$store.dispatch(`${name}/reset`); //Reset state
  },
};
</script>
